import css_text from '/srv/www/htdocs/loc/app/styles/web_components/checkbox.css';

const CHECK_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 11 12 10"> <path fill="currentColor" d="M14.4444 17.5556L12.0556 15.1667C11.8519 14.963 11.5926 14.8611 11.2778 14.8611C10.963 14.8611 10.7037 14.963 10.5 15.1667C10.2963 15.3704 10.1944 15.6296 10.1944 15.9444C10.1944 16.2593 10.2963 16.5185 10.5 16.7222L13.6667 19.8889C13.8889 20.1111 14.1481 20.2222 14.4444 20.2222C14.7407 20.2222 15 20.1111 15.2222 19.8889L21.5 13.6111C21.7037 13.4074 21.8056 13.1481 21.8056 12.8333C21.8056 12.5185 21.7037 12.2593 21.5 12.0556C21.2963 11.8519 21.037 11.75 20.7222 11.75C20.4074 11.75 20.1481 11.8519 19.9444 12.0556L14.4444 17.5556Z" /> </svg>`;
export class YalwaCheckbox extends HTMLElement {
	
	static formAssociated = true;
	
	static get observedAttributes() {
		return ['intent', 'size', 'disabled', 'checked', 'value', 'mark_required'];
	}
	
	constructor() {
		super();
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
		}
		this._internals = this.attachInternals ? this.attachInternals() : null;
		this.apply_css();
		this.initialize_template();
		
		this.addEventListener('click', this.on_click);
		this.addEventListener('keydown', this.on_keydown);
	}
	
	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		const sheet = new CSSStyleSheet();
		sheet.replaceSync(css_text);
		this.shadowRoot.adoptedStyleSheets = [sheet];
	}
	
	initialize_template() {
		if (!this.shadowRoot.firstChild) {
			const template = document.createElement('template');
			template.innerHTML = `
				<div class="wrapper" part="wrapper" style="display:none;">
                    <span class="box" part="box">
                        <slot name="check_icon">${CHECK_ICON}</slot>
                    </span>
                    <span class="label" part="label">
                        <slot></slot>
                    </span>
				</div>
			`;
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.core_element = this.shadowRoot.querySelector('.wrapper');
	}
	
	connectedCallback() {
		if (!this.hasAttribute('tabindex')) {
			this.setAttribute('tabindex', '0');
		}
		this.upgrade_properties(['intent', 'size', 'checked', 'value', 'disabled', 'mark_required']);
		this.render();
		jQuery(this).removeClass('invisible');
	}
	
	upgrade_properties(props) {
		props.forEach(prop => {
			if (this.hasOwnProperty(prop)) {
				let value = this[prop];
				delete this[prop];
				this[prop] = value;
			}
		});
	}
	
	attributeChangedCallback(name, old_value, new_value) {
		if (old_value === new_value) {
			return;
		}
		if (name === 'checked' || name === 'value') {
			this.update_form_state();
		}
		if (name === 'disabled') {
			this.setAttribute('tabindex', new_value !== null ? '-1' : '0');
		}
		this.render();
	}
	
	render() {
		if (!this.core_element) {
			return;
		}
		this.core_element.setAttribute('data-state', this.checked ? 'checked' : 'unchecked');
		this.core_element.toggleAttribute('data-disabled', this.disabled);
		this.core_element.toggleAttribute('data-mark_required', this.mark_required);
		this.core_element.setAttribute('data-intent', this.getAttribute('intent') || 'default');
        this.core_element.setAttribute('data-size', this.getAttribute('size') || 'm');
		if (this._internals) {
			this._internals.ariaChecked = this.checked ? 'true' : 'false';
			this._internals.ariaDisabled = this.disabled ? 'true' : 'false';
		}
	}
	
	get checked() {
		return this.hasAttribute('checked');
	}
	
	set checked(value) {
		if (value) {
			this.setAttribute('checked', '');
		} else {
			this.removeAttribute('checked');
		}
	}
	
	get value() {
		return this.getAttribute('value') || 'on';
	}
	
	set value(value) {
		this.setAttribute('value', value);
	}
	
	get disabled() {
		return this.hasAttribute('disabled');
	}
	
	set disabled(value) {
		if (value) {
			this.setAttribute('disabled', '');
		} else {
			this.removeAttribute('disabled');
		}
	}
	
	get mark_required() {
		return this.hasAttribute('mark_required');
	}
	
	set mark_required(value) {
		if (value) {
			this.setAttribute('mark_required', '');
		} else {
			this.removeAttribute('mark_required');
		}
	}
	
	update_form_state() {
		if (this.checked) {
			this._internals?.setFormValue(this.value);
		} else {
			this._internals?.setFormValue(null);
		}
	}
	
	on_click(event) {
		if (this.disabled) {
			return;
		}
		this.toggle();
	}
	
	on_keydown(event) {
		if (this.disabled) {
			return;
		}
		if (event.key === ' ') {
			event.preventDefault();
			this.toggle();
		}
	}
	
	toggle() {
		this.checked = !this.checked;
		this.dispatchEvent(new Event('change', {bubbles: true, composed: true}));
	}
	
	// --- Properties ---
	
	// Form association properties
	get form() {
		return this._internals?.form ?? null;
	}
	
	get name() {
		return this.getAttribute('name');
	}
	
	get type() {
		return this.localName;
	}
}

customElements.define('yalwa-checkbox', YalwaCheckbox);